<template>
  <div class="view-project">
    <!-- Use ProjectCreation component in view mode -->
    <ProjectCreation 
      :editProjectId="projectId"
      :viewMode="true"
      @navigate="handleNavigation"
    />
  </div>
</template>

<script>
import ProjectCreation from './ProjectCreation.vue'

export default {
  name: 'ViewProject',
  components: {
    ProjectCreation
  },
  props: {
    projectId: {
      type: String,
      required: true
    }
  },
  methods: {
    handleNavigation(destination, params = {}) {
      // Pass navigation events up to parent
      this.$emit('navigate', destination, params)
    }
  }
}
</script>

<style scoped>
.view-project {
  min-height: 100vh;
}
</style>